import React, { useState, useEffect } from "react"
import { sfxPlay } from "@/assets/audios/sfx"
import type { AnimationType, ChessColor } from "@/store/animation"
import styles from "./index.module.scss"

const blackBurnFrames = [
    require("@/assets/imgs/chess/blackBurn/0.png"),
    require("@/assets/imgs/chess/blackBurn/1.png"),
    require("@/assets/imgs/chess/blackBurn/2.png"),
    require("@/assets/imgs/chess/blackBurn/3.png"),
    require("@/assets/imgs/chess/blackBurn/4.png"),
    require("@/assets/imgs/chess/blackBurn/5.png"),
    require("@/assets/imgs/chess/blackBurn/6.png"),
    require("@/assets/imgs/chess/blackBurn/7.png"),
    require("@/assets/imgs/chess/blackBurn/8.png"),
    require("@/assets/imgs/chess/blackBurn/9.png"),
    require("@/assets/imgs/chess/blackBurn/10.png"),
    require("@/assets/imgs/chess/blackBurn/11.png"),
    require("@/assets/imgs/chess/blackBurn/12.png"),
    require("@/assets/imgs/chess/blackBurn/13.png"),
    require("@/assets/imgs/chess/blackBurn/14.png"),
    require("@/assets/imgs/chess/blackBurn/15.png"),
    require("@/assets/imgs/chess/blackBurn/16.png"),
    require("@/assets/imgs/chess/blackBurn/17.png"),
    require("@/assets/imgs/chess/blackBurn/18.png"),
    require("@/assets/imgs/chess/blackBurn/19.png"),
    require("@/assets/imgs/chess/blackBurn/20.png"),
]

const blackBreakFrames = [
    require("@/assets/imgs/chess/blackBreak/6.png"),
    require("@/assets/imgs/chess/blackBreak/7.png"),
    require("@/assets/imgs/chess/blackBreak/8.png"),
    require("@/assets/imgs/chess/blackBreak/9.png"),
    require("@/assets/imgs/chess/blackBreak/10.png"),
    require("@/assets/imgs/chess/blackBreak/11.png"),
    require("@/assets/imgs/chess/blackBreak/12.png"),
    require("@/assets/imgs/chess/blackBreak/13.png"),
    require("@/assets/imgs/chess/blackBreak/14.png"),
    require("@/assets/imgs/chess/blackBreak/15.png"),
    require("@/assets/imgs/chess/blackBreak/16.png"),
    require("@/assets/imgs/chess/blackBreak/17.png"),
    require("@/assets/imgs/chess/blackBreak/18.png"),
    require("@/assets/imgs/chess/blackBreak/19.png"),
    require("@/assets/imgs/chess/blackBreak/20.png"),
]

const whiteBurnFrames = [
    require("@/assets/imgs/chess/whiteBurn/0.png"),
    require("@/assets/imgs/chess/whiteBurn/1.png"),
    require("@/assets/imgs/chess/whiteBurn/2.png"),
    require("@/assets/imgs/chess/whiteBurn/3.png"),
    require("@/assets/imgs/chess/whiteBurn/4.png"),
    require("@/assets/imgs/chess/whiteBurn/5.png"),
    require("@/assets/imgs/chess/whiteBurn/6.png"),
    require("@/assets/imgs/chess/whiteBurn/7.png"),
    require("@/assets/imgs/chess/whiteBurn/8.png"),
    require("@/assets/imgs/chess/whiteBurn/9.png"),
    require("@/assets/imgs/chess/whiteBurn/10.png"),
    require("@/assets/imgs/chess/whiteBurn/11.png"),
    require("@/assets/imgs/chess/whiteBurn/12.png"),
    require("@/assets/imgs/chess/whiteBurn/13.png"),
    require("@/assets/imgs/chess/whiteBurn/14.png"),
    require("@/assets/imgs/chess/whiteBurn/15.png"),
    require("@/assets/imgs/chess/whiteBurn/16.png"),
    require("@/assets/imgs/chess/whiteBurn/17.png"),
    require("@/assets/imgs/chess/whiteBurn/18.png"),
    require("@/assets/imgs/chess/whiteBurn/19.png"),
    require("@/assets/imgs/chess/whiteBurn/20.png"),
]

const whiteBreakFrames = [
    require("@/assets/imgs/chess/whiteBreak/6.png"),
    require("@/assets/imgs/chess/whiteBreak/7.png"),
    require("@/assets/imgs/chess/whiteBreak/8.png"),
    require("@/assets/imgs/chess/whiteBreak/9.png"),
    require("@/assets/imgs/chess/whiteBreak/10.png"),
    require("@/assets/imgs/chess/whiteBreak/11.png"),
    require("@/assets/imgs/chess/whiteBreak/12.png"),
    require("@/assets/imgs/chess/whiteBreak/13.png"),
    require("@/assets/imgs/chess/whiteBreak/14.png"),
    require("@/assets/imgs/chess/whiteBreak/15.png"),
    require("@/assets/imgs/chess/whiteBreak/16.png"),
    require("@/assets/imgs/chess/whiteBreak/17.png"),
    require("@/assets/imgs/chess/whiteBreak/18.png"),
    require("@/assets/imgs/chess/whiteBreak/19.png"),
    require("@/assets/imgs/chess/whiteBreak/20.png"),
]

interface ChessAnimationProps {
    type: AnimationType
    color: ChessColor
    onComplete?: () => void
}

export const ChessAnimation: React.FC<ChessAnimationProps> = ({
    type,
    color,
    onComplete = () => {},
}) => {
    const [frameIndex, setFrameIndex] = useState(0)
    const [isComplete, setIsComplete] = useState(false)

    // 根据类型和颜色选择对应的帧序列
    const frames =
        type === "burn" && color === "black"
            ? blackBurnFrames
            : type === "burn" && color === "white"
              ? whiteBurnFrames
              : type === "break" && color === "black"
                ? blackBreakFrames
                : whiteBreakFrames
    useEffect(() => {
        if (frameIndex >= frames.length - 1) {
            setIsComplete(true)
            onComplete()
            return
        }

        const timer = setTimeout(() => {
            setFrameIndex(frameIndex + 1)
        }, 60)

        return () => clearTimeout(timer)
    }, [frameIndex])

    return (
        !isComplete && (
            <img src={frames[frameIndex]} className={styles.animation} />
        )
    )
}
